import { useCallback } from "react";
import { useAbortController, useIsMounted } from "@contember/react-utils";
import { useBindingOperations } from "./useBindingOperations.js";
import { useEnvironment } from "./useEnvironment.js";
import { DataBindingExtendAborted } from "../core/DataBinding.js";
const useExtendTree = () => {
  const abort = useAbortController();
  const { extendTree } = useBindingOperations();
  const isMountedRef = useIsMounted();
  const environment = useEnvironment();
  return useCallback(async (newFragment, options) => {
    try {
      const newTreeRootId = await extendTree(
        newFragment,
        { environment, ...options, signal: abort() }
      );
      if (!isMountedRef.current) {
        return;
      }
      return newTreeRootId;
    } catch (e) {
      if (e === DataBindingExtendAborted) {
        return;
      }
      throw e;
    }
  }, [abort, environment, extendTree, isMountedRef]);
};
export {
  useExtendTree
};
//# sourceMappingURL=useExtendTree.js.map
